import { createSlice } from '@reduxjs/toolkit';
import { removeUsers } from '../../lib';
import { resetApplication } from '../application/slice';
import usersState from './state';
export const usersSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => usersState);
    },
    initialState: usersState,
    name: 'users',
    reducers: {
        errorReceiveInviteUser: {
            prepare: email => {
                return {
                    payload: {
                        email
                    }
                };
            },
            reducer: (state, action) => {
                const { email } = action.payload;
                state.failedToInviteUsers.push(email);
                state.requestingInviteUser = false;
            }
        },
        errorReceiveRemoveUsers: state => {
            state.requestingRemoveUsers = false;
        },
        errorReceiveUpdateUserAuthConnection: state => {
            state.requestingUpdateUserAuthConnection = false;
        },
        errorReceiveUserRoles: state => {
            state.requestingUserRoles = false;
        },
        errorReceiveUsers: state => {
            state.requestingUsers = false;
            state.users = undefined;
        },
        failedReceiveInviteUser: {
            prepare: email => {
                return {
                    payload: {
                        email
                    }
                };
            },
            reducer: (state, action) => {
                const { email } = action.payload;
                state.failedToInviteUsers.push(email);
                state.requestingInviteUser = false;
            }
        },
        failedReceiveRemoveUsers: state => {
            state.requestingRemoveUsers = false;
        },
        failedReceiveUpdateUserAuthConnection: state => {
            state.requestingUpdateUserAuthConnection = false;
        },
        failedReceiveUserRoles: state => {
            state.requestingUserRoles = false;
        },
        failedReceiveUsers: state => {
            state.requestingUsers = false;
            state.users = undefined;
        },
        receiveInviteUser: state => {
            state.requestingInviteUser = false;
        },
        receiveInviteUsers: state => {
            state.requestingInviteUsers = false;
        },
        receiveRemoveUsers: {
            prepare: selectedUsers => {
                return {
                    payload: {
                        selectedUsers
                    }
                };
            },
            reducer: (state, action) => {
                const { selectedUsers } = action.payload;
                state.requestingRemoveUsers = false;
                state.users = removeUsers(state.users, selectedUsers);
            }
        },
        receiveUpdateUserAuthConnection: state => {
            state.requestingUpdateUserAuthConnection = false;
        },
        receiveUserRoles: state => {
            state.requestingUserRoles = false;
        },
        receiveUsers: {
            prepare: users => {
                return {
                    payload: {
                        users
                    }
                };
            },
            reducer: (state, action) => {
                const { users } = action.payload;
                state.requestingUsers = false;
                state.users = users;
            }
        },
        requestInviteUser: {
            prepare: (email, roles, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        email,
                        roles
                    }
                };
            },
            reducer: state => {
                state.failedToInviteUsers = [];
                state.requestingInviteUser = true;
            }
        },
        requestInviteUsers: {
            prepare: (emails, roles, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        emails,
                        roles
                    }
                };
            },
            reducer: state => {
                state.failedToInviteUsers = [];
                state.requestingInviteUsers = true;
            }
        },
        requestRemoveUsers: {
            prepare: (selectedUsers, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        selectedUsers
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveUsers = true;
            }
        },
        requestUpdateUserAuthConnection: {
            prepare: (email, authConnection) => {
                return {
                    payload: {
                        authConnection,
                        email
                    }
                };
            },
            reducer: state => {
                state.requestingUpdateUserAuthConnection = true;
            }
        },
        requestUpdateUserRoles: {
            prepare: (email, roles, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        email,
                        roles
                    }
                };
            },
            reducer: state => {
                state.requestingUserRoles = true;
            }
        },
        requestUsers: {
            prepare: (organizationSlug, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        organizationSlug
                    }
                };
            },
            reducer: state => {
                state.requestingUsers = true;
            }
        },
        resetFailedInviteUsers: state => {
            state.failedToInviteUsers = [];
        },
        resetUsers: () => usersState
    }
});
export const { errorReceiveInviteUser, errorReceiveRemoveUsers, errorReceiveUpdateUserAuthConnection, errorReceiveUserRoles, errorReceiveUsers, failedReceiveInviteUser, failedReceiveRemoveUsers, failedReceiveUpdateUserAuthConnection, failedReceiveUserRoles, failedReceiveUsers, receiveInviteUser, receiveInviteUsers, receiveRemoveUsers, receiveUpdateUserAuthConnection, receiveUserRoles, receiveUsers, requestInviteUser, requestInviteUsers, requestRemoveUsers, requestUpdateUserAuthConnection, requestUpdateUserRoles, requestUsers, resetFailedInviteUsers, resetUsers } = usersSlice.actions;
export default usersSlice.reducer;
